import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  AdditionalAnswerModel,
  CustomAnswerModel,
  ComparisonAnswers
} from '../../models/comparison/comparison-answers';
import { TypeSpecification } from '../../models/enums';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()

export class AnswerService {
  public answerSetModel: ComparisonAnswers = new ComparisonAnswers();
  // public answerSetModel: ComparisonAnswers = new ComparisonAnswers({"customAnswers":[{"type":3,"specification":1,"questionId":10,"optionId":1},{"type":6,"specification":5,"questionId":11,"digit":1},{"type":2,"specification":0,"questionId":24,"optionId":50},{"type":2,"specification":0,"questionId":25,"optionId":52},{"type":2,"specification":0,"questionId":28,"optionId":60},{"type":3,"specification":0,"questionId":29,"optionId":63},{"type":7,"specification":0,"questionId":21,"optionId":30},{"type":5,"specification":4,"questionId":12,"date":"2019-09-18T21:00:00.000Z"},{"type":2,"specification":0,"questionId":31,"optionId":78}],"specialAnswers":[{"questionId":1,"property":5,"answer":1},{"questionId":2,"property":4,"answer":2018},{"questionId":3,"property":6,"answer":3},{"questionId":4,"property":7,"answer":"A3 1.4 TFSI cod ultra"}],"additionalAnswer":[],"profileAnswers":[[{"type":0,"specification":2,"questionId":5,"text":"dgh"},{"type":0,"specification":3,"questionId":6,"text":"hdd"},{"type":0,"specification":7,"questionId":7,"text":"fhg@sdf.com"},{"type":0,"specification":8,"questionId":9,"text":"dsf"},{"type":5,"specification":6,"questionId":8,"date":"2019-09-24T21:00:00.000Z"},{"type":3,"specification":0,"questionId":15,"optionId":8},{"type":5,"specification":0,"questionId":16,"date":"2019-09-17T21:00:00.000Z"},{"type":7,"specification":0,"questionId":17,"optionId":11},{"type":2,"specification":0,"questionId":20,"optionId":24},{"type":7,"specification":0,"questionId":13,"optionId":5},{"type":7,"specification":0,"questionId":14,"optionId":7}]],"typeId":"1","specification":1,"compareIdentifier":"00000000-0000-0000-0000-000000000000"});
  public $answerSetModel: BehaviorSubject<ComparisonAnswers> = new BehaviorSubject<ComparisonAnswers>(this.answerSetModel);
  // public companyId: number;

  constructor(private authService: OAuthService) {
    const claims = this.authService.getIdentityClaims() as any;
    if (claims) {
      this.answerSetModel.userId = claims.sub;
    }
  }

  public emitChange() {
    this.$answerSetModel.next(this.answerSetModel);
  }

  public setTypeId(typeId: number) {
    this.answerSetModel.typeId = typeId;
    this.$answerSetModel.next(this.answerSetModel);
  }

  public setSpecification(specification: TypeSpecification) {
    this.answerSetModel.specification = specification;
    this.$answerSetModel.next(this.answerSetModel);
  }

  public setCompany(id: number) {
    this.answerSetModel.companyId = id;
    this.$answerSetModel.next(this.answerSetModel);
  }

  public setCustomAnswers(customAnswers: CustomAnswerModel[]) {
    this.answerSetModel.customAnswers = customAnswers;
    this.$answerSetModel.next(this.answerSetModel);
  }

  public setAdditionalAnswer(additionalAnswerModel: AdditionalAnswerModel | AdditionalAnswerModel[]) {
    if (additionalAnswerModel instanceof AdditionalAnswerModel) {
      additionalAnswerModel = [additionalAnswerModel];
    }
    additionalAnswerModel.forEach(x => {
      const currentUnswer = this.answerSetModel.additionalAnswer
        .find(y => y.additionalId === x.additionalId && y.companyId === x.companyId);
      if (currentUnswer) {
        if (typeof x.isSelected === 'boolean') {
          currentUnswer.isSelected = x.isSelected;
        }
        if (typeof x.inputValue === 'number') {
          currentUnswer.inputValue = x.inputValue;
        }
      } else {
        this.answerSetModel.additionalAnswer.push(x);
      }
    });

    this.$answerSetModel.next(this.answerSetModel);
  }

  public changeAnswerSetModelEvent(): Observable<ComparisonAnswers> {
    return this.$answerSetModel.asObservable();
  }


}
